<template>
	<div class="full">
		<vxe-grid ref="inputinvoicedetailtransferunitTable" v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		props: {
			invoicedata: {
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				list_footerField:[
					{field:'price',toFixed:4}
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				gridOptions.toolbarConfig.buttons = [{
					name: '自动转换',
					status: 'success',
					code: 'transfer'
				},{
					name: '保存',
					status: 'danger',
					code: 'save'
				}]
				gridOptions.columns = [{
						type: 'checkbox',
						title: '#',
						width:50
					},{
						field: 'cargoName',
						title: '项目名称',
					},
					{
						field: 'amount',
						title: '数量',
					},
					{
						field: 'unit',
						title: '单位'
					},
					{
						field: 'unitPrice',
						title: '单价',
					},
					{
						field: 'price',
						title: '金额',
					},
					{
						field: 'nazhi_unitratio',
						title: '约等于几件',
						editRender:{
							name:"$inputNumber",
							props:{
								precision:4
							}
						}
						
					},
					{
						field: 'nazhi_minimumunit',
						title: '最小单位',
					},
					// {
					// 	title: '操作',
					// 	fixed: "right",
					// 	align: 'center',
					// 	width: 65,
					// 	slots: {
					// 		default: ({row}) => {
					// 			return [<el-button type = "text" size = "mini" onClick = {() => {this.ddcode(row)}}>凭证</el-button>]
					// 		}
					// 	}
					// }
				]
				gridOptions.formConfig = false
				gridOptions.pagerConfig.enabled = false
			},
			list() {
				return new Promise((resolve) => {
					this.$api.invoice.getinputinvoicedetail({
						invoiceId:this.invoicedata.invoiceId,
						action:'transferunit'
					}).then((res)=>{
						resolve({
							list: res
						})
					})
					// let groupdata = this.$Lodash.groupBy(this.data, 'bankAcc')
					// for(let i in groupdata){
					// 	let obj = {}
					// 	obj.id = groupdata[i][0].id
					// 	obj.bankAcc = i
					// 	obj.accName = groupdata[i][0].accName
					// 	obj.needamount = this.$Lodash.sumBy(groupdata[i], item=>parseFloat(item.needamount))
					// 	obj.needamount = obj.needamount.toFixed(2)
					// 	data.push(obj)
					// }
					// console.log(data)

				})
			},
			transfer(){
				let data = this.$refs.inputinvoicedetailtransferunitTable.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return false
				}
				this.$confirm('自动转换会覆盖当前值，是否确认自动转换').then(()=>{
					let cargoId = data.map((item)=>{
						return item.cargoId
					})
					this.$api.invoice.inputinvoicedetailunittransfer({
						cargoId:cargoId
					}).then(()=>{
						this.$refs.inputinvoicedetailtransferunitTable.commitProxy('query')
						this.$emit('transferunitSave')
					},()=>{
						
					})
				})
			},
			save(){
				let data = this.$refs.inputinvoicedetailtransferunitTable.getTableData().fullData
				let param = data.map((item)=>{
					return {
						cargoId:item.cargoId,
						nazhi_unitratio:item.nazhi_unitratio,
					}
				})
				this.$api.invoice.inputinvoicedetailunitsave({
					data:param
				}).then(()=>{
					this.$refs.inputinvoicedetailtransferunitTable.commitProxy('query')
					this.$emit('transferunitSave')
				},()=>{
					
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>